import CropperControl from "./CropperControl";

export default CropperControl;
